import '@babel/polyfill'
import '../commons/styles/footer.scss'
import App from "./RepairApply"
import CommonHeader from '../commons/components/CommonHeader'
import CommonFooter from '../commons/components/CommonFooter'
import 'vue-area-linkage/dist/index.css'
import VueAreaLinkage from 'vue-area-linkage'
Vue.use(VueAreaLinkage)
import request from '../commons/utils/request'
Vue.prototype.$request = request
Vue.config.productionTip = false;
new Vue({
  render: (h) => h(App),
}).$mount("#app")
new Vue({
  render: h => h(CommonHeader, {
    props: {
      active: 'serviceindex'
    }
  }),
}).$mount('#header')

new Vue({
  render: h => h(CommonFooter)
}).$mount('#footerCommon')

